// @ts-expect-error moduleResolution:nodenext issue 54523
import { html, LitElement, nothing } from 'lit';
import { IProduct } from "../models/IProduct"
// @ts-expect-error moduleResolution:nodenext issue 54523
import { customElement, property, state } from 'lit/decorators.js';
import LightElement from './light-element.js';
import Helpers from '../../typescript/modules/helpers.js';
import Ecommerce from '../../typescript/modules/ecommerce.js';
import { live } from 'lit/directives/live.js';
import { createRef, ref, Ref } from 'lit/directives/ref.js';
import { classMap } from 'lit/directives/class-map.js';
import AlgoliaTracking from '../../typescript/modules/algolia-tracking.js';
import Logger from '../../typescript/modules/Logger.js';
import Tracking from '../../typescript/modules/tracking.js';
import {IViewItemGA4Item} from "../models/IViewItemGA4Item";

declare var dataLayer: any;

@customElement('product-add')
export default class ProductAdd extends LightElement {

	@property({ type: String })
	name: string;

	@property({ type: String })
	sku: string;

	@property({ type: String })
	displayName: string;

	@property({ type: String })
	guid: string;

	@property({ type: Number })
	price: number;

	@property({
		converter: {
			fromAttribute: (value) => {
				let result = value;
				try {
					result = JSON.parse(value) as JSON;
				} catch (x) {
					result = value;
					console.error(`Could not JSON.parse value ${value}`);
				}
				return result;
			},
			toAttribute: (value) => {
				try {
					return JSON.stringify(value);
				} catch (x) {
					console.error(`Could not JSON.stringify value ${value}`);
					return '';
				}
			}
		}

	})
	viewItemEventInfo: IViewItemGA4Item;

	@property({ type: String, reflect: true })
	loggerSource: string;

	@property({ type: String })
	message: string;

	@property({ reflect: true })
	quantity: number = 0;

	@property({ type: Boolean })
	disableAddToBasket: boolean;

	@property({ type: Boolean })
	primaryButton: boolean;

	@property({ type: Function })
	onChangeQuantity: (quantity: number) => void;

	@property({ type: Boolean })
	slim: boolean;

	@property({ type: Boolean })
	isComparisonProduct: boolean = false;

	@state()
	private isSaving = false;

	@state()
	private lastQuantity = 0;

	@state()
	private quantityDifference = 0;

	@state()
	private errorMessage = "";

	private requestTimer: any;

	private ajaxUrl = '/api/basketadd/addorupdateajax/';

	private moreRef: Ref<HTMLInputElement> = createRef();

	connectedCallback() {
		super.connectedCallback();
		this.checkIfShouldSync();
		this.makeSureLoggerSourceIsSet();
		document.addEventListener('updateAddedProducts', this.checkIfShouldSync.bind(this));
	}

	disconnectedCallback() {
		super.disconnectedCallback();
		document.removeEventListener('updateAddedProducts', this.checkIfShouldSync.bind(this));
	}

	private makeSureLoggerSourceIsSet() {
		if (!this.loggerSource) {
			if (this.closest('product-card') && this.closest('product-card').hasAttribute('addbuttonloggersource')) {
				this.loggerSource = this.closest('product-card').getAttribute('addbuttonloggersource');
			}
		}
	}

	private checkIfShouldSync() {
		if (!(<any>window).addedProducts) {
			return;
		}
		const found = (<any>window).addedProducts.find((product) => product.id === this.name && product.sku === this.sku);
		if (found) {
			this.quantity = found.quantity;
			this.lastQuantity = found.quantity;
		}
	}

	private handleChangeQuantity(quantity: number, isAdd?: boolean) {
		if (this.onChangeQuantity) {
			this.onChangeQuantity(quantity);
		}
		if (this.disableAddToBasket) {
			this.quantity = this.lastQuantity;
			return;
		}

		// if no quantity reset to 0
		if (!quantity) {
			quantity = 0;
		}

		if (!this.isValidQuantity(quantity)) {
			this.quantity = this.lastQuantity;
			const quantityInput = this.querySelector('.js-add-product-quantity') as HTMLInputElement;
			if (quantityInput) {
				quantityInput.value = this.quantity.toString();
			}
			return;
		}

		this.quantity = quantity;
		clearTimeout(this.requestTimer);
		const requestTimer = setTimeout(() => {
			this.updateBasket()
				.then((response: any) => {
					this.isSaving = false;
					this.errorMessage = "";
					this.updateAddedProducts();
					this.trackAddComparisonProductToBasket(this.name, this.displayName, this.quantityDifference, this.price);
					if (isAdd) {
						const moreButton = this.moreRef.value!;
						moreButton.focus();
					}
					Ecommerce.updateBasketCounts(response.BasketTotalItemQuantity);
				}).
				catch((error: Error) => {
					this.isSaving = false;
					this.errorMessage = "Error adding to basket";
					Logger.trackException(error, 'Error in add to basket from product card');
				});
		}, isAdd ? 0 : 500);
		this.requestTimer = requestTimer;
	}

	private updateAddedProducts() {
		if (!(<any>window).addedProducts) {
			(<any>window).addedProducts = [];
		}
		const found = (<any>window).addedProducts.find((product) => product.id === this.name && product.sku === this.sku);
		if (found) {
			for (let i = 0; i < (<any>window).addedProducts.length; i++) {
				if ((<any>window).addedProducts[i].id === this.name && (<any>window).addedProducts[i].sku === this.sku) {
					(<any>window).addedProducts[i].quantity = this.lastQuantity;
					break;
				}
			}
		} else {
			(<any>window).addedProducts.push({
				id: this.name,
				sku: this.sku,
				quantity: this.lastQuantity,
				price: this.price
			});
		}

		const updateAddedProductsEvent = Helpers.createCustomEventForDispatch('updateAddedProducts', {
			id: this.name,
			sku: this.sku,
			quantity: this.quantityDifference,
			price: this.price
		});
		document.dispatchEvent(updateAddedProductsEvent);

	}

	private updateBasket() {
		this.quantityDifference = this.quantity - this.lastQuantity;
		const body = 'id=' + this.name + '&quantity=' + this.quantityDifference + '&sku=' + this.sku;
		this.lastQuantity = this.quantity;
		this.isSaving = true;

		Logger.trackTrace(`Add to basket called from product card with: ${body}`);

		return fetch(this.ajaxUrl, {
			method: 'POST',
			credentials: 'same-origin',
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded',
				'Cache-Control': 'no-cache'
			},
			body: body
		}).then((response) => {
			if (response.ok) {
				this.trackAddToBasket();
				return response.json();
			} else { throw new Error(response.text.toString()); }

		});
	}

	private isValidQuantity(value: number) {
		if (isNaN(value)) {
			this.errorMessage = "Please enter a quantity";
			Logger.trackException(new Error(`Invalid quantity ${value} in add to basket button on product card`));
			return false;
		}
		this.errorMessage = "";
		return true;
	}

	private trackAddToBasket() {
		this.viewItemEventInfo.quantity = Math.abs(this.quantityDifference);
		const listParent = this.closest('[data-list-id]');
		if (listParent) {
			this.viewItemEventInfo.list_item_id = listParent.getAttribute('data-list-id');
			this.viewItemEventInfo.list_item_name = listParent.getAttribute('data-list-name');
		}
		dataLayer.push({ ecommerce: null });
		dataLayer.push({
			event: this.quantityDifference > 0 ? 'add_to_cart' : 'remove_from_cart',
			ecommerce: {
				value: (this.price * Math.abs(this.quantityDifference)).toFixed(2),
				items: [this.viewItemEventInfo]
			}
		});

		if (this.quantityDifference > 0) {
			AlgoliaTracking.addedToCart(
				[this.guid],
				[{
					price: this.price,
					quantity: Math.abs(this.quantityDifference)
				}],
				Helpers.roundToTwoDecimals(this.price * Math.abs(this.quantityDifference))
			);
		}

		Logger.trackTrace(`Add to basket from product card success: ${this.displayName} added to basket with quantity ${this.quantityDifference}.`);
	}

	private trackAddComparisonProductToBasket(productId: string, productName: string, quantity: number, price: number) {
		if (quantity > 0 && this.isComparisonProduct) {
			Tracking.customEvent('add_comparison_product_to_basket', {
				ecommerce: {
					items: [
						{
							item_id: productId,
							item_name: productName,
							quantity: quantity,
							price: price
						}
					]
				}
			});
		}
	}

	render() {

		return html`
			<form class="c-add-product ${classMap({ "c-add-product--slim": this.slim })} js-product-add" novalidate="novalidate" id="add-product-upsell-product-${this.name}" @submit="${(event) => event.preventDefault()}">
			${this.quantity > 0 ?
				html`
				<div class="c-add-product__controls ${classMap({ "c-add-product__controls--large": this.primaryButton })}">
					<button @click="${this.handleChangeQuantity.bind(this,this.quantity - 1, false)}" ?disabled=${this.isSaving} class="c-button c-button--full c-button--secondary c-add-product__controls__less" type="button" data-test="upsell-product-decrease-quantity"><span class="u-visuallyhidden">Remove one ${this.displayName} from your basket</span></button>
					<label class="u-visuallyhidden" for="add-product-upsell-product-input-${this.name}">Product quantity</label>
					<input type="text" @change=${(event) => this.handleChangeQuantity(parseInt(event.target.value), false)} inputmode="numeric" id="add-product-upsell-product-input-${this.name}" ?disabled=${this.isSaving} class="c-add-product__controls__text js-add-product-quantity" .value="${live(this.quantity)}" pattern="^[0-9]*$" data-value-before-change="0" data-test="upsell-product-quantity">
					<button @click="${this.handleChangeQuantity.bind(this, this.quantity + 1, false)}" ?disabled=${this.isSaving} ${ref(this.moreRef)} class="c-button c-button--full c-button--secondary c-add-product__controls__more" type="button" data-test="upsell-product-increase-quantity"><span class="u-visuallyhidden">Add another ${this.displayName} to your basket</span></button>
				</div>`
			: html`<button type="button" @click="${this.handleChangeQuantity.bind(this, 1, true)}" ?disabled=${this.isSaving} class="c-button c-button--full ${classMap({ "c-button--emphasize": this.primaryButton, "c-button--large": this.primaryButton, "c-button--secondary": !this.primaryButton })} c-add-product__button js-ignore-product-card-click" data-test="upsell-product-add-to-basket">${!this.primaryButton ? html`<span aria-hidden="true">+</span> ` : null}Add <span class="u-visuallyhidden">${this.displayName}</span><span class="c-add-product__button__detail ${classMap({ "c-add-product__button__detail--always-show": this.primaryButton })}"> to Basket</span></button>`}
				<input name="quantity" value="${this.quantity}" class="js-add-product-quantity-actual c-add-product__debug" type="hidden">
				<input type="hidden" name="sku" value="${this.sku}" class="js-add-product-sku">
				<input type="hidden" name="id" value="${this.name}" class="js-add-product-id">
				<input type="hidden" name="guid" value="${this.guid}">
				<input type="hidden" name="displayName" value="${this.displayName}">
				<input type="hidden" name="price" value="${this.price}">
				${this.errorMessage ?
				html`<p class="c-add-product__message c-add-product__message--error" data-test="upsell-product-added-to-your-basket-error">${this.errorMessage}</p>`
				: nothing}
				${!this.errorMessage && this.lastQuantity > 0 ?
				html`<product-viewer-open-button-message productId="${this.name}"></product-viewer-open-button-message>`
				: nothing
				}
			</form>
		`;

	}

}
